import React, { useContext } from 'react';
import { Button, Col } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { ImportModal } from '../../../../components';
import { downloadFile } from '../../../../services/utils';
import { sendAlert } from '../../../../actions/utils';
import { PayrollProcessContext } from '../../../RemunerationProcesses/context/PayrollProcessProvider';
import {
  exportReliquidationBalancesRequest,
  importReliquidationBalancesRequest,
  importTemplateReliquidationBalancesRequest,
  preImportReliquidationBalancesRequest
} from '../../../../requests/reliquidationBalances';

const Actions = ({
  setModalState,
  params,
  setActiveComponent,
  setOnRequest,
  setMoreData,
  setSimpleModalState,
  onlyShow
}) => {
  const dispatch = useDispatch();
  const { reliquidationProcess } = useContext(PayrollProcessContext);

  const handleDownload = filterOptions => {
    setOnRequest(true);
    exportReliquidationBalancesRequest({
      dispatch,
      params: { ...filterOptions, sort_by_employee_field: 'full_name', sort_direction: 'asc' },
      format: '.xlsx',
      successCallback: response => {
        downloadFile(response);
      },
      failureCallback: () => {
        dispatch(sendAlert({ kind: 'error', message: 'Error al descargar el archivo' }));
      },
      callback: () => {
        setOnRequest(false);
        setModalState(state => ({ ...state, show: false }));
      }
    });
  };

  const handleModalClose = () => {
    setModalState(state => ({
      ...state,
      body: <></>,
      show: false
    }));
  };

  const handleImportModalExceptions = error => {
    if (error?.response?.status === 422) {
      const alertInfo = <pre>{error?.response?.data?.message}</pre>;
      setModalState({
        title: 'Importar Haberes',
        body: alertInfo,
        show: true,
        action: handleModalClose
      });
    } else {
      dispatch(sendAlert({ kind: 'error', message: error?.response?.data?.message }));
    }
  };

  const handleExport = exportType => {
    switch (exportType) {
      case 'export_benefits':
        setModalState({
          title: 'Exportar Haberes',
          body: '¿Estás seguro que deseas descargar los Haberes?',
          show: true,
          action: () =>
            handleDownload({
              ...params,
              filter_type: 'asset',
              filter_reliquidation_process_ids: reliquidationProcess.id
            })
        });
        break;

      case 'import_benefits':
        setSimpleModalState({
          title: 'Importar Haberes',
          body: (
            <ImportModal
              onDropUploaded={preImportReliquidationBalancesRequest}
              handleTemplate={importTemplateReliquidationBalancesRequest}
              onHide={importReliquidationBalancesRequest}
              hideModal={() => setSimpleModalState(oldState => ({ ...oldState, show: false }))}
              updateData={() => setMoreData(oldValue => !oldValue)}
              handleExceptions={handleImportModalExceptions}
              params={{
                reliquidation_process_id: reliquidationProcess.id
              }}
              service="payroll"
            />
          ),
          show: true
        });
        break;
      default:
        break;
    }
  };

  const changeComponentTo = component => {
    setActiveComponent(component);
  };

  return (
    <>
      <Col />
      <Col md={2}>
        <Button variant="primary" block onClick={() => handleExport('export_benefits')}>
          Exportar
        </Button>
      </Col>
      {!onlyShow && (
        <>
          <Col md={2}>
            <Button variant="primary" block onClick={() => handleExport('import_benefits')}>
              Importar
            </Button>
          </Col>
          <Col md={2}>
            <Button variant="primary" block onClick={() => changeComponentTo('ReliquidationBalances')}>
              Nuevo
            </Button>
          </Col>
        </>
      )}
    </>
  );
};

export default Actions;
